<svg
    width="340"
    height="187"
    viewBox="0 0 340 187"
    xmlns="http://www.w3.org/2000/svg">
 <!-- Roof Border -->


    <!-- Roof -->
    <svg:path
        class="outer-roof"
        d="M152.161 174.681 L20.6152 101.886 L198.299 0.81543 L329.833 73.6091 L152.161 174.681Z" />
    <svg:path
        d="M155.271 162.95 L41.4775 99.9697 L195.181 12.5371 L308.977 75.5132 L155.271 162.95Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [width]="300"
        [height]="300"
        [x]="-30"
        [y]="-20"
        app-roof-box></g>


        <g
        [width]="300"
        [height]="300"
        [x]="30"
        [y]="-60"
        app-roof-box></g>   


</svg>